<template>
  <div class="template-wrap day-event-template" v-bind:class="computedClass">
    <div class="subject">
      <span>{{ data.subject }}</span>
      <span>
        {{ data.FriendlyStatus }}
      </span>
    </div>
    <div class="description">
      <span>{{ data.ProductCode }}</span> -
      <span>{{ data.ProductDescription1 }} </span>
    </div>
    <div class="data">
      <div class="data-items">
        <div class="planned">
          <span>Planned </span>&nbsp;
          <span>
            {{ getFormattedQty(data.RequiredQty) }}
            {{ data.StockUM }}
          </span>
        </div>
        <div class="actual">
          <span>Actual</span>&nbsp;
          <span>
            {{ getFormattedQty(data.RequiredQty) }}
            {{ data.StockUM }}
          </span>
        </div>
      </div>
      <GcCommentIcon v-if="data.HasNote === 'Y'" class="calendar-comment" />
    </div>
  </div>
</template>

<script>
import { formatNumber } from "devextreme/localization";
import GcCommentIcon from "../gc-comment-icon.vue";
export default {
  components: { GcCommentIcon },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    getFormattedQty(value) {
      return formatNumber(value, "##,###,###,###,##0.00");
    },
  },
  computed: {
    computedClass() {
      const status = this.data.FriendlyStatus
        ? this.data.FriendlyStatus.toFriendlyStatus()
        : false;
      return {
        active: status === "Active",
        inproduction: status === "In Production",
        completed: status === "Completed",
        cancelled: status === "Cancelled",
        draft: status === "Draft",
      };
    },
  },
};
</script>

<style lang="scss">
.e-appointment-details {
  .day-event-template {
    padding: 5px 5px;

    .subject {
      display: flex;
      justify-content: space-between;
      font-size: 14px;
    }

    .subject span:last-child {
      font-size: 10px;
    }

    .description {
      font-size: 12px;
    }

    .data {
      font-size: 10px;
      display: inline-flex;
      justify-content: space-between;
      width: 100%;

      .data-items {
        display: flex;
      }

      .actual {
        padding-left: 25px;
      }
    }
  }
}
</style>
